import { Component, Input} from '@angular/core';

@Component({
  selector: 'ltts-happy-guage-chart',
  templateUrl: './happy-guage-chart.component.html',
  styleUrls: ['./happy-guage-chart.component.scss']
})
export class HappyGuageChartComponent {
   @Input() happyData: any;
  @Input() dataPercent:any;

  gaugeOption: any;

  ngOnChanges(): void {
    if (!this.happyData) return;
    this.buildChartOption();
  }

  buildChartOption(){
    this.gaugeOption = {
    tooltip: {
      trigger: "item",
      borderRadius: 20,
      padding: 5,
      backgroundColor: "#fff",

      formatter: (params: any) => {
        // Map label → image
        const imgMap: any = {
          "WFO": "happy.png",
          "WFA": "happy-wfo.png",
        };

        const imgFile = imgMap[params.name] || "default.png";

        return `
            <div style="display:flex;align-items:center;gap:6px;">
              <img style="width:24px;height:24px;" 
                   src="/assets/feedback-icons/${imgFile}"/>
                   (<strong>${params.name}</strong>)${params.value}% 
            </div>
          `;
      }
    },
    legend: {
        // Desktop Position: Vertical, on the right side
        
        
        top: "85%",
        itemWidth: 20,
        itemHeight: 20,
        selectedMode: false,
        textStyle: {
          color: "#003F72",
          fontSize: 14,
        },
        
        formatter: (name: string) => {
          let count = 0;
          let percent = 0;
          if (name === "WFO") {
            count = this.happyData.wfocount.toLocaleString('en-US');
            percent = Math.round(this.happyData.wfopercent);
          } else if (name === "WFA") {
            count = this.happyData.wfhcount.toLocaleString('en-US');
            percent = Math.round(this.happyData.wfhpercent);
          } 


          return `(${Math.round(percent)}%) ${name} `;
        },

        data: [
          {
            name: "WFO", // Must match series name
            icon: `image:///assets/feedback-icons/happy.png`,
          },
          {
            name: "WFA", // Must match series name
            icon: `image:///assets/feedback-icons/happy-wfo.png`,
          },
          
        ],
      },

    graphic: {
      type: "group",
      left: "31%",
      top: "center",
      children: [
        {
          type: "circle",
          shape: { r: 50 },
          style: {
            fill: "#ffffff",
            shadowColor: "rgba(0,0,0,0.15)",
            shadowBlur: 15,
            shadowOffsetX: 0,
            shadowOffsetY: 4,
          },
        },
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: `{t1|Total}\n{t2|${this.dataPercent}%}\n{t3|(${(this.happyData.wfocount+this.happyData.wfhcount).toLocaleString('en-US')})}`,
            fontSize: 18,
            textAlign: "center",
            textVerticalAlign: "middle",
            rich: {
              t1: {
                fontSize: 14,
                fill: "#003F72",
                fontWeight: 500
              },
              t2: {
                fontSize: 22,
                fill: "#003F72",
                fontWeight: 700
              }
              ,
              t3: {
                fontSize: 12,
                fill: "#112868",
                fontWeight: 700
              }
            }
          }
        }
      ],
    },

    series: [
      {
        name: "Mood",
        type: "pie",
        center: ["48.5%", "50%"],
        radius: ["80%", "90%"],
        startAngle: 210,
        endAngle: -30,

        itemStyle: {
          borderRadius: 8,
          borderColor: "#fff",
          borderWidth: 2,
        },

        label: {
          show: false,
          position: "outside",
          formatter: (params: any) => params.name,
          fontSize: 14,
          fontWeight: 600,
          color: "#003F72",
        },
        labelLine: {
        show: false,
    },

        data: [
          { value: Math.round(this.happyData.wfopercent), name: "WFO", itemStyle: { color: "#2DC725" } },
          { value: Math.round(this.happyData.wfhpercent), name: "WFA", itemStyle: { color: "#6AFF62" } },
          
        ],
      },
    ],
  };
  }
}
